import { render, staticRenderFns } from "./ClickAndBuy.vue?vue&type=template&id=7b022c54&scoped=true"
import script from "./ClickAndBuy.vue?vue&type=script&lang=js"
export * from "./ClickAndBuy.vue?vue&type=script&lang=js"
import style0 from "./ClickAndBuy.vue?vue&type=style&index=0&id=7b022c54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b022c54",
  null
  
)

export default component.exports